import { webServiceCall } from "../services/pantherService";

const cache = {};

export const fetchFlag = async (guid, methodName) => {
  const cacheKey = `${guid}_${methodName}`;
  if (cacheKey in cache) return cache[cacheKey];

  try {
    const result = await webServiceCall(methodName, { GUId: guid });

    if (!result || !Array.isArray(result) || result.length === 0) {
      const fallback = methodName === "GetStripeTopupOptions" ? [] : false;
      cache[cacheKey] = fallback;
      return fallback;
    }

    let value;
    const data = result[0];

    switch (methodName) {
      case "GetStripeTopupOptions":
        value = data.OnlineTopUpAmounts
          .split(",")
          .map((v) => Number(v.trim()));
        break;

      case "CheckShowBalance":
        value = data.ShowAccountBalance === 1;
        break;

      default:
        value = data[""] === 1;
        break;
    }

    cache[cacheKey] = value;
    return value;
  } catch (err) {
    console.error(`Error fetching ${methodName}:`, err);
    const fallback = methodName === "GetStripeTopupOptions" ? [] : false;
    cache[cacheKey] = fallback;
    return fallback;
  }
};

export default fetchFlag;
